import { Skeleton, TableCell, TableRow } from "@mui/material";

export default function LoadingTableRows({
  elementsCount,
}: {
  elementsCount: string | number;
}) {
  return (
    <>
      <TableRow
        children={Array.from(Array(elementsCount).keys()).map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      />
      <TableRow
        children={Array.from(Array(elementsCount).keys()).map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      />
      <TableRow
        children={Array.from(Array(elementsCount).keys()).map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      />
      <TableRow
        children={Array.from(Array(elementsCount).keys()).map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      />
      <TableRow
        children={Array.from(Array(elementsCount).keys()).map((_, index) => (
          <TableCell key={index}>
            <Skeleton />
          </TableCell>
        ))}
      />
    </>
  );
}
